import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Vignette from './views/Vignette.vue'
import Advices from './views/Advices.vue'
import AfterBuyingOnline from './views/AfterBuyingOnline.vue'
import Test from './views/Test.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/en'
    },
    {
      path: '/:locale/comic/advices/:step',
      name: 'advices',
      component: Advices
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/:locale/comic/test-knowledge',
      name: 'test-knowledge',
      component: Test
    },
    {
      path: '/:locale/comic/:step',
      name: 'vignette',
      component: Vignette
    },
    {
      path: '/:locale/after-buying-online',
      name: 'after-buying-online',
      component: AfterBuyingOnline
    },
    {
      path: '/:locale',
      name: 'home',
      component: Home
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
